import React from 'react';
import { Calendar, Send } from 'lucide-react';

export default function RelanceCard({ name, task, time }) {
  return (
    <div className="bg-primary-card p-4 rounded-lg shadow-md hover:shadow-green transition-all cursor-pointer border border-transparent hover:border-accent-green/30">
      <div className="flex items-start justify-between gap-2 mb-2">
        <h4 className="text-white font-medium truncate min-w-0">{name}</h4>
        <button className="text-accent-green hover:text-accent-light transition-all p-1 hover:bg-accent-green/10 rounded flex-shrink-0">
          <Send size={16} />
        </button>
      </div>
      <p className="text-text-gray text-sm mb-2">{task}</p>
      <p className="text-xs text-accent-green flex items-center gap-1">
        <Calendar size={12} />
        {time}
      </p>
    </div>
  );
}
